import { apiClient, ApiClientConfig, PaginatedRequestParams } from 'api';
export type CreateLabelDTO = {
  title?: string;
  description?: string | null;
};
export type UpdateLabelDTO = {
  id?: string;
  title?: string;
  description?: string;
  title_arabic?: string;
  description_arabic?: string;
};
export const BookingReportApiService = () => {
  const baseURL = process.env.REACT_APP_BASE_V2_URL;
  // const baseURL='https://localhost:7046/api'
  const getbookingreport = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/FacilityRevenueContracts`,
      params,
    });

    return response.data;
  };
  const getPackageBooking = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/admin/report/reportBookings`,
      params,
    });

    return response.data;
  };

  return {
    getbookingreport,
    getPackageBooking,
  };
};
